import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['exportForm', 'spinner']
  static values = { armKey: { type: String, default: '' } }

  showSpinner() {
    this.exportFormTarget.classList.add('d-none')
    this.spinnerTarget.classList.remove('d-none')
    if (this.armKeyValue) sessionStorage.setItem(this.armKeyValue, '1')
  }

  restoreForm() {
    this.spinnerTarget.classList.add('d-none')
    this.exportFormTarget.classList.remove('d-none')
  }

  handleResponse(event) {
    if (!event.detail.success) this.restoreForm()
  }
}
